<div class="page page--not-found">
    <h1>404</h1>
    <p>Page not found.</p>
    <a href="#/">Go to Dashboard</a>
</div>

<style lang="scss">
    .page--not-found {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        text-align: center;
    }

    p {
        color: $color-text;
        margin: 0.5em 0 1.5em;
    }
</style>
